import styled from "styled-components";
import {OptInWinHighlightDefaultBox} from "./opt-in-win-highlight.default.box";

export const OptInWinHighlightMRGreenBox = styled(OptInWinHighlightDefaultBox)`
    width: 140px;
    box-shadow: 
        0px 0px 5px 0px #B1E1C5 inset,
        0px 0px 15px 0px #01FF9166 inset,
        0px 0px 20px 0px #B1E1C533;

    background-color: #00120E; 
    background-image: radial-gradient( #293835 20%, #00120E 50%);

    border: 1.6px solid #B1E1C5;
    margin: 4px 6px;
`
